import React, { Component } from 'react'
import PropTypes from 'prop-types'
import ReactMarkdown from 'react-markdown'

import { CircularProgress } from '@material-ui/core'

import Profile from '../../classes/profile'

class ChatOpenAI extends Component {
  static propTypes = {
    profile: Profile.PropTypes,
    shortcut: PropTypes.shape({
      id: PropTypes.string.isRequired,
      expires_at: PropTypes.string.isRequired,
      target: PropTypes.string.isRequired,
      target_id: PropTypes.string
    }),
    threadId: PropTypes.string,
    selectedViewAssistantId: PropTypes.string,
    messages: PropTypes.array,
    sendMessage: PropTypes.func,
    isFetching: PropTypes.bool,
    apiError: PropTypes.string
  }

  constructor (props) {
    super(props)

    this.state = {
      message: '',
      errorMessage: false
    }

    this.chatWindowRef = React.createRef()
  }

  componentDidUpdate (prevProps) {
    if (prevProps.messages.length !== this.props.messages.length) {
      this.scrollToBottom()
    }
  }

  handleChange = (e) => {
    this.setState({ message: e.target.value })
    if (e.target.value.length > 0) {
      this.setState({ errorMessage: false })
    }
  }

  handleKeyDown = (event) => {
    if (event.key === 'Enter' && !event.shiftKey && !this.props.isFetching) {
      event.preventDefault();
      this.handleSubmit(event);
    }
  }

  handleSubmit = (e) => {
    e.preventDefault()
    if (this.state.message.length > 0) {
      const isBurner = this.props.shortcut ? true : false
      const burnerId = this.props.shortcut ? this.props.shortcut.id : null
      const user = {}
      if (this.props.profile && !this.props.shortcut) {
        user.email = this.props.profile.email
        user.groups = this.props.profile.groups
      }
      this.props.sendMessage(this.state.message, this.props.threadId, this.props.selectedViewAssistantId, isBurner, burnerId, JSON.stringify(user))
      this.setState({
        message: '',
        errorMessage: false
      })
    } else {
      this.setState({
        errorMessage: true
      })
    }
  }

  scrollToBottom = () => {
    if (this.chatWindowRef.current) {
      this.chatWindowRef.current.scrollTop = this.chatWindowRef.current.scrollHeight
    }
  }

  render () {
    const error = (this.props.apiError && this.props.apiError.error && this.props.apiError.error.detail) ? this.props.apiError.error.detail : ''
    return (
      <div className='chat-bot'>
        <div className="chat-window" ref={this.chatWindowRef}>
          { this.props.messages.map((msg, index) => (
            <div key={index} className={msg.sender}>
              <ReactMarkdown>{msg.text.replace(/【\d+:\d+†source】/g, '').replace(/【\d+:\d+†[\w\-_.]+】/g, '')}</ReactMarkdown>
            </div>
          )) }
          { this.props.isFetching && <CircularProgress /> }
          { (this.props.apiError && !this.props.isFetching && error.indexOf('OpenAI') > -1) && <div>
            We're experiencing an outage with our AI model provider, please try your request again in 20 minutes. Thank you for your understanding!
            </div>
          }
          { (this.props.apiError && !this.props.isFetching && error.indexOf('OpenAI') < 0) && <div>
            Thanks for your patience. It seems that something is going on and an alert has been sent to the Diesel Support Team. We will look into this immediately; please check back again soon.
            </div>
          }
        </div>
        <form className="chat-form" onSubmit={this.handleSubmit}>
          <textarea
            value={this.state.message}
            onChange={this.handleChange}
            onKeyDown={this.handleKeyDown}
            placeholder="Hi! I know what audiences are saying about media content and brands, ask me anything!"
          />
          <button type="submit" disabled={this.props.isFetching}>
            <img src='/static/images/send.svg' alt="Send" className="send-icon" />
          </button>
        </form>
        <div className="hint">
          <span className="prompt">{this.state.errorMessage ? 'Prompt is required' : ''}</span>
          <p>Shift + Enter to add a new line</p>
        </div>
      </div>
    )
  }
}

export default ChatOpenAI